import { UiUtilities } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PaymentInputContextProvider } from 'context';

import { PageHeading } from 'components';
import InteractiveSummaryLayout from 'components/Layout/InteractiveSummaryLayout';
import { LoadingPageAnimation } from 'components/LoadingPageAnimation';
import { PaymentInformation } from 'components/PaymentInformation';
import ProgressBar from 'components/ProgressBar';

import { LoungeInteractiveProductSummary } from '../../components';
import { useLoungePaymentInputPage } from './hooks';
import './styles.scss';

const PaymentInputPage: React.FC = () => {
  const { t } = useTranslation();
  const isDesktop = UiUtilities.useMediaMatch('--viewport-l');

  return (
    <div className="lounges-pip">
      <PaymentInputContextProvider>
        <PaymentInputPageInner t={t} isDesktop={isDesktop} />
      </PaymentInputContextProvider>
    </div>
  );
};

const PaymentInputPageInner: React.FC<{
  t: ReturnType<typeof useTranslation>['t'];
  isDesktop: boolean;
}> = ({ t, isDesktop }) => {
  const { isPageReady, paymentInformationFormProps, productSummaryProps } =
    useLoungePaymentInputPage();

  if (!isPageReady) {
    return <LoadingPageAnimation />;
  }

  return (
    <div className="form-container-wrapper">
      <div className="form-container container">
        <div className="content">
          <ProgressBar />
          <PageHeading text={t('Header - Payment')} />
          {productSummaryProps && !isDesktop && (
            <InteractiveSummaryLayout>
              <LoungeInteractiveProductSummary {...productSummaryProps} />
            </InteractiveSummaryLayout>
          )}
          {paymentInformationFormProps && <PaymentInformation {...paymentInformationFormProps} />}
        </div>
        {productSummaryProps && isDesktop && (
          <InteractiveSummaryLayout>
            <LoungeInteractiveProductSummary {...productSummaryProps} />
          </InteractiveSummaryLayout>
        )}
      </div>
    </div>
  );
};

export default PaymentInputPage;
